import { FC, useState } from "react";
import { DateComponent, NumberComponent } from "../Elements/FlowBuilderDynamicInput";
import { capitalize } from "lodash";
import { ComparisonType } from "reducers/flow-builder.reducer";
import FlowBuilderInput from "../Elements/FlowBuilderInput";
import AutoComplete from "components/AutoCompletev2";
import { useDebounce } from "react-use";
import TrashIcon from "pages/Personv2/icons/TrashIcon";
interface FormRowProps {
  children: React.ReactNode;
}

export const FormRow: FC<FormRowProps> = (props: FormRowProps) => {
  return (
    <div className="w-full flex flex-col gap-[10px] mt-[10px]">
      {props.children}
    </div>
  )
}


enum RangeDirectionType {
  from = "from",
  to = "to"
}

interface BasicDateRangeProps {
  value: { from: string, to: string };
  onChange: (value: any) => void;
}

export const BasicDateRange: FC<BasicDateRangeProps> = (props) => {
  const [dateRange, setDateRange] = useState<BasicDateRangeProps['value']>(props.value || { from: "", to: "" });

  const onChange = (dir: RangeDirectionType) => (value: any) => {
    const composedValue = { ...dateRange, [dir]: value };
    props.onChange?.(composedValue);
    setDateRange(composedValue);
  }

  return (
    <div className="flex gap-2 items-center">
      <DateComponent
        value={dateRange.from}
        onChange={onChange(RangeDirectionType.from)}
      />
      <span>to</span>
      <DateComponent
        value={dateRange.to}
        onChange={onChange(RangeDirectionType.to)}
      />
    </div>
  )
}

interface BasicNumberRangeProps {
  value: { from: string, to: string };
  onChange: (value: any) => void;
}

export const BasicNumberRange: FC<BasicNumberRangeProps> = (props) => {
  const [numbersRange, setDateRange] = useState<BasicNumberRangeProps['value']>(props.value || { from: "", to: "" });

  const onChange = (dir: RangeDirectionType) => (value: any) => {
    const composedValue = { ...numbersRange, [dir]: value };
    setDateRange(composedValue);
    props.onChange?.(composedValue);
  }


  return (
    <div className="flex gap-2 items-center">
      <NumberComponent
        value={numbersRange.from}
        onChange={onChange(RangeDirectionType.from)}
      />
      <span>to</span>
      <NumberComponent
        value={numbersRange.to}
        onChange={onChange(RangeDirectionType.to)}
      />
    </div>
  )
}

export const InlineForm: FC<any> = (props) => {
  return (
    <FormRow>
      <div className="flex max-w-[924px] relative w-full flex-nowrap items-center">
        <div className="gap-[10px] w-full bg-[#F3F4F6] p-[10px] rounded flex justify-start items-start">
          {props.children}
        </div>
      </div>
    </FormRow>
  )
}

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  placeholder?: string
}

export const SearchInput: FC<SearchInputProps> = (props) => {
  const { options = [], onChange, placeholder } = props;
  const [searchKey, setSearchKey] = useState(props.value);

  const onSelect = (value: string) => {
    setSearchKey(value);
  }

  const onSearch = (value: string) => {
    setSearchKey(value);
  }

  useDebounce(() => {
    onChange(searchKey);
  }, 200, [searchKey]);

  return (
    <AutoComplete
      value={searchKey}
      onQueryChange={onSearch}
      onSelect={onSelect}
      includedItems={{
        type: "getter",
        items: options.map((item) => item),
      }}
      retrieveLabel={(item) => item}
      getKey={(value) => value}
      placeholder={placeholder}
    />
  )
}


// the user input values and then clicks enter or click on the add button to add to the list of values
const MultiValuesTextInput: FC<any> = (props) => {
  const { values = [] } = props;
  const [inputValue, setInputValue] = useState<string>("");

  const onAddValue = () => {
    if (inputValue) {
      const isValueExist = values.includes(inputValue);
      if (isValueExist) {
        return;
      }
      const newValues = [...(values || []), inputValue];
      props.onAdd?.(newValues);
      setInputValue("");
    } else {
      console.log("Empty value")
    }
  }

  const onRemoveValue = (value: string) => {
    const newValues = values.filter((val: string) => val !== value);
    props.onAdd?.(newValues);
  }

  return (
    <div className="flex gap-2 items-start">
      <div className="flex flex-col gap-2 items-start">
        <div className="flex gap-2 items-start">
          <input
            type="text"
            value={inputValue}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                onAddValue();
              }
            }}
            onChange={(event) => setInputValue(event.target.value)}
            className="w-[150px] px-[12px] py-[5px] font-inter font-normal text-[14px] leading-[22px] border border-[#E5E7EB] placeholder:font-inter placeholder:font-normal placeholder:text-[14px] placeholder:leading-[22px] placeholder:text-[#9CA3AF] rounded-sm"
          />
          <button
            onClick={onAddValue}
            className="px-[10px] py-[5px] bg-[#2563EB] text-white font-inter font-normal text-[14px] leading-[22px] rounded-sm"
          >
            Add
          </button>
        </div>
        <div className="flex gap-1 flex-wrap">
          {values.map((value: string) => (
            <span key={value} className="flex gap-1 items-center px-[10px] py-[5px] text-[#2563EB] bg-white font-inter font-normal text-[14px] leading-[22px] rounded-sm">
              <span>
                {value}
              </span>
              <span onClick={() => onRemoveValue(value)} className="w-[15px] h-[15px] cursor-pointer">
                <TrashIcon className='hover:text-[tomato]' />
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}





export const SuitableInputFiled: FC<any> = (props) => {
  const { field } = props;
  switch (field.type) {
    case "multiple":
      return (
        <select
          // value={field.value}
          onChange={(event: any) => {
            props.onChange?.(event.target.value);
          }}
          className="w-[150px] px-[12px] py-[5px] font-inter font-normal text-[14px] leading-[22px] border border-[#E5E7EB] placeholder:font-inter placeholder:font-normal placeholder:text-[14px] placeholder:leading-[22px] placeholder:text-[#9CA3AF] rounded-sm"
        >
          {field?.options?.map(({ key, title }: { key: string, title: string }) => (
            <option key={key} value={key}>
              {capitalize(title)}
            </option>
          ))}
        </select>
      );
    case "number_between":
      return (
        <BasicNumberRange
          value={field.value}
          onChange={(value: any) => {
            props.onChange?.(value);
          }}
        />
      );
    case ComparisonType.DURING:
      return (
        <BasicDateRange
          value={field.value}
          onChange={(value: any) => {
            props.onChange?.(value);
          }}
        />
      );
    case 'string':
      return (
        <FlowBuilderInput
          value={field.value}
          onChange={(value: any) => {
            props.onChange?.(value);
          }}
        />
      )
    case 'autocomplete':
      return (
        <SearchInput
          value={field.value}
          onChange={(value: any) => {
            props.onChange?.(value);
          }}
          options={field.options}
          placeholder={field.placeholder}
        />
      )

    case 'multiple_selections':

      return (
        <MultiValuesTextInput
          values={field.value}
          onAdd={(value: any) => {
            props.onChange?.(value);
          }}
        />
      );
    default:
      // @note: adding a fallback component may be a good idea, but it will cause a confusion
      return null
  }
}

